import IntegrationTable from "@/components/shared/IntegrationTable/IntegrationTable";
import MundShipOffers from "../icons/MundShipOffers";
import ShipOffersIcon from "../icons/ShipOffers";
import { integrationFieldPresets } from "@/components/shared/IntegrationTable/integrationFieldPresets";
import { useTranslation } from "react-i18next";

export default function ShipOffers() {
  const { t } = useTranslation(["common", "integration"]);
  return (
    <IntegrationTable
      integrationKey="ship_offers"
      title="ShipOffers"
      main_icon={<MundShipOffers />}
      icon={<ShipOffersIcon />}
      fields={[
        integrationFieldPresets.access_token,
        integrationFieldPresets.secret_token,
        integrationFieldPresets.metadata,
        integrationFieldPresets.status,
      ]}
      fixedValues={{
        active_statuses: ["paid", "refunded"],
      }}
      fieldLabels={{
        access_token: t("integration:ship_offers_api_username"),
        placeholder_access_token: t("integration:ship_offers_api_username_placeholder"),
        secret_token: t("integration:ship_offers_api_password"),
        placeholder_secret_token: t("integration:ship_offers_api_password_placeholder"),
        metadata: t("integration:ship_offers_store_id"),
        placeholder_metadata: t("integration:ship_offers_store_id_placeholder"),
      }}
    />
  );
}

